import comp from "./ManageStudentActivity";

export default comp;
